import { VALENTINE_EVENT_DELIVERY_PROMISE } from '@client/config/constants';
import { Campaign } from '@shared/types/mylounge';

export const useDeliveryLabel = (campaign: Campaign) => {
    const isSpecialDeliveryBanner = [VALENTINE_EVENT_DELIVERY_PROMISE].includes(
        campaign?.deliveryPromise?.type,
    );

    return { isSpecialDeliveryBanner };
};
